<template>
  <li class="calendar-day" :class="{'calendar-day--not-current': !day.isCurrentMonth, 'calendar-day--today': isToday }"
      @click="manageDailyMenu()">
    <span>{{ label }}</span>
    <div v-if="dayDetails !== undefined || Object.keys(dayDetails).length !== 0">
      <p style="height: 6px;">&nbsp;</p>
      <vs-tooltip :text="dayDetails.soupName">
        <p class="menuDetail" :class="{'warning' : dayDetails.soupName === 'Hiányzó leves'}">{{ dayDetails.soupName }}</p>
      </vs-tooltip>
      <vs-tooltip :text="dayDetails.aMainName">
        <p class="menuDetail" :class="{'warning' : dayDetails.aMainName === 'Hiányzó A menü'}">{{
            dayDetails.aMainName
          }}</p>
      </vs-tooltip>
      <vs-tooltip :text="dayDetails.bMainName">
        <p class="menuDetail" :class="{'warning' : dayDetails.bMainName === 'Hiányzó B menü'}">{{
            dayDetails.bMainName
          }}</p>
      </vs-tooltip>
      <vs-tooltip :text="dayDetails.cMainName">
        <p class="menuDetail" :class="{'warning' : dayDetails.cMainName === 'Hiányzó C menü'}">{{
            dayDetails.cMainName
          }}</p>
      </vs-tooltip>
      <vs-tooltip :text="dayDetails.dietName">
        <p class="menuDetail" :class="{'warning' : dayDetails.dietName === 'Hiányzó kímélő menü'}">{{
            dayDetails.dietName
          }}</p>
      </vs-tooltip>
      <vs-tooltip :text="dayDetails.extraName">
        <p class="menuDetail" :class="{'warning' : dayDetails.extraName === 'Hiányzó extra'}">{{
            dayDetails.extraName
          }}</p>
      </vs-tooltip>
    </div>
  </li>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "CalendarMonthDayItem",
  props: {
    day: {
      type: Object,
      required: true,
    },

    isCurrentMonth: {
      type: Boolean,
      default: false,
    },

    isToday: {
      type: Boolean,
      default: false,
    },
    dayDetails: {
      default: function () {
        return {
          MenuDate: this.day.date,
          IdSoup: '',
          IdMainA: '',
          IdMainB: '',
          IdNainC: '',
          IdDiet: '',
          IdExtra: ''
        }
      }
    },
  },
  computed: {
    label() {
      return dayjs(this.day.date).format("D");
    }
  },
  methods: {
    manageDailyMenu() {
      let payload = {...this.dayDetails};
      if (payload.MenuDate === undefined)
        payload.MenuDate = this.day.date
      this.$emit("openDailyMenuModal", payload);
    }
  }
};
</script>

<style scoped>
.calendar-day {
  position: relative;
  min-height: 100px;
  font-size: 13px;
  background-color: ghostwhite;
  color: var(--grey-800);
  padding: 5px;
  cursor: pointer;
  transition: 0.25s all linear;
  border: 2px solid transparent;
  box-sizing: border-box;
}

.calendar-day:hover {
  border-color: #BBB;
}

.calendar-day > span {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 2px;
  width: var(--day-label-size);
  height: var(--day-label-size);
}

.calendar-day--not-current {
  background-color: var(--grey-100);
  color: var(--grey-300);
}

.calendar-day--today {
  padding-top: 4px;
}

.calendar-day--today > span {
  color: #fff;
  border-radius: 9999px;
  background-color: var(--grey-800);
}

.menuDetail {
  padding: 0 3px;
  margin: 0;
  max-width: 210px;
  max-height: 16px;
  background: linear-gradient(to right, #32de84, #1DB954);
  font-size: 12px;
  box-sizing: border-box;
  color: #000;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-shadow: 0 -1px 0 0 inset #333;
  transition: 0.2s all linear;
}

.menuDetail:hover {
  filter: brightness(115%);
}
.warning {
  background: linear-gradient(to right, #f8d879, #c88808);
}
</style>
